
export default {
  name: 'TechnicalFilterHelp',
  props: {
    filterKey: {
      type: String,
      required: true,
      validator: value => ['watts', 'lumens'].includes(value),
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    buttonClass: {
      type: [String, Array, Object],
      default: '',
    },
    iconClass: {
      type: [String, Array, Object],
      default: 'tw-text-gray-400',
    },
  },
  computed: {
    title() {
      return this.$t(
        `components.productTechnicalFilters.${this.filterKey}Title`
      )
    },
    openLabel() {
      return this.$t('components.technicalFilterHelp.open', {
        filter: this.title,
      })
    },
  },
  methods: {
    popoverTarget() {
      const trigger = this.$refs.trigger

      return trigger ? trigger.$el || trigger : null
    },
  },
}
